/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { FETCH_LOCATIONS_TO_ROLE_REQUEST, FETCH_LOCATIONS_TO_ROLE_SUCCESS, FETCH_LOCATIONS_TO_ROLE_FAILURE } from './types';
import { IPage } from '../../../models/Roles/Locations';
import { pageData } from '../../../components/RoleDetails/constants';

export const locationsReducerInitialState: {
  locations: string[];
  page: IPage;
  loading: boolean;
  error: null;
} = {
  locations: [],
  page: pageData,
  loading: false,
  error: null
};

export const locationToRoleReducer = (state = locationsReducerInitialState, action: any) => {
  switch (action.type) {
    case FETCH_LOCATIONS_TO_ROLE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_LOCATIONS_TO_ROLE_SUCCESS:
      const locations = action.locations.map((location: string) => ({ name: location }));
      return {
        ...state,
        locations: locations,
        page: action.page,
        loading: false,
        error: null
      };

    case FETCH_LOCATIONS_TO_ROLE_FAILURE:
      return {
        ...state,
        locations: [],
        page: pageData,
        loading: false,
        error: action.error
      };
    default:
      return state;
  }
};
